import { render, staticRenderFns } from "./HotelPendingChangesList.vue?vue&type=template&id=3131d984&scoped=true&"
import script from "./HotelPendingChangesList.vue?vue&type=script&lang=js&"
export * from "./HotelPendingChangesList.vue?vue&type=script&lang=js&"
import style0 from "./HotelPendingChangesList.vue?vue&type=style&index=0&id=3131d984&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3131d984",
  null
  
)

export default component.exports